import React, { useEffect } from 'react'
import vic3 from '../../../Assets/claimpro-design-home/mediumCrane.dd5ddd290d5430bda120 3.png'
import vic2 from '../../../Assets/claimpro-design-home/mediumRecoveryVan.4c4853cb8ac45f55b93e 2.png'
import vic4 from '../../../Assets/claimpro-design-home/images 3.png'
import vic5 from '../../../Assets/claimpro-design-home/BV-Acharya-56-removebg-preview.6310376e2f948c019163 1.png'
import vic6 from '../../../Assets/claimpro-design-home/full-length-portrait-of-an-auto-mechanic-pointing-to-a-hand-truck-with-car-tires-isolated-on-white-background-2AMH47C 1.png'
import logo from '../../../Assets/home/logo.svg'
import CurrentOrdersList from '../VendorResponsesCustomer/CurrentOrdersList';
import bgImage from '../../../Assets/claimpro-design-home/steptodown.com188373.jpg';
import BottomNavigationCustomer from './BottomNavigatonCustomer';
import { useNavigate } from 'react-router-dom'

function AllServices() {
  const navigate = useNavigate();

  const handleClick = (serviceType) => {
    // Keep your navigation or modal logic here
    navigate(`/add-new-vehicle-driver`);
  }

    useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    scrollToTop();
    const timeoutId = setTimeout(() => {
      scrollToTop();
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className='font-satoshi'>
      <style>
        {`
      .banner-overlay{
  background-color: rgba(0, 0, 0, 0.491);
  padding: 40px 20px;

}
.banner{
  background-image: url(${bgImage});
  background-size: cover;
  background-position: right;

}
.banner h3{
  color: #fff;
  text-align: center;
  font-size: 35px;
  font-weight: 600;
  margin-top: 20px;
   
}
  .Banner{
  padding:0 20px;
  background-image: url(./Assets/Group\ 155.png);
  background-size: cover;
  background-position: center;
  padding-top: 80px;
  padding-bottom: 200px;
  color: white;
  text-align: center;
}
.Banner h3{
  font-size: 25px;
  font-weight: 700;
}
  .banner-div{
    background-image: url(./Assets/background.png);
    background-size: cover;
    padding: 20px;
    border-radius: 20px;
}
    .banner-left{
    width: 60%;
}
.banner-right{
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.banner-right img{
  width: 180px;
}
.banner-left h3{
    font-size: 18px;
    color: white;
}
.banner-left p{
     font-size: 10px;
    color: white;
    margin-top: 10px;
}
.banner-left button{
     font-size: 6px;
    color: white;
    background-color: black;
    border-radius: 20px;
    padding: 0 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 16px;

}
    .banner-div{
    display: flex;
    flex-direction: row;
}
      .services-boxs{
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 110px;
}
      .home-services-boxs{
  padding: 20px;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 20px;
}
      .newservices-boxs{
  /* padding: 20px; */
  /* background-color: #21a6e91e; */
  border-radius: 10px;
  width: 45%;
  transition: all 0.3s;

}
.newservices-boxs-img{
  height: 100px;
  /* background-color: #21a6e90f; */
  padding: 20px;
  padding-top: 10;
  display: flex;
  justify-content: center;
  align-items: center;

}
.newservices-boxs:hover{
  background-color: #21a6e90f;
}
.newservices-boxs-img img{
  /* width: 100%; */
  height: 80px;
  /* object-fit: cover; */
}
.newservices-boxs-text{
  background-color: #21A6E9;
  padding: 10px;
  border-radius: 0 0 10px 10px;
}
.newservices-boxs-text p{
  font-size: 13px;
  font-weight: 600;
  color: white;

}
.newservices-boxs-text h6{
  font-size: 10px;
  font-weight: 400;
  color: white;
  margin-top: 5px;

}
.newservices-boxs-text-arrow{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}
.newservices-boxs-text-arrow i{
  color: white;
}`}

      </style>

      <div className="nav fixed top-0">
        <div  className="logo rounded-full">
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/logo-compressed.png'/>
        </div>
        
    </div>

      <div className='banner mt-[4rem]'>
        <div className='banner-overlay'>
          <h3>Services</h3>
        </div>
      </div>

      <div className='services-boxs'>
        <div className='newservices-boxs' onClick={() => handleClick('recovery-van')}>
          <div className='newservices-boxs-img'>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/mediumRecoveryVan.4c4853cb8ac45f55b93e+2.png' alt="" />
          </div>
          <div className='newservices-boxs-text'>
            <p>Recovery Van</p>
            <div className='newservices-boxs-text-arrow'>
              <h6>Stuck? We Move You Forward </h6>
              {/* <i className="bi bi-arrow-right-circle-fill"></i> */}
            </div>
          </div>
        </div>

        <div className='newservices-boxs' onClick={() => handleClick('hydra-crane')}>
          <div className='newservices-boxs-img'>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/mediumCrane.dd5ddd290d5430bda120+3.png' alt="" />
          </div>
          <div className='newservices-boxs-text'>
            <p>Hydra Crane</p>
            <div className='newservices-boxs-text-arrow'>
              <h6>Powerful Lifting. Nationwide Reach </h6>
              {/* <i className="bi bi-arrow-right-circle-fill"></i> */}
            </div>
          </div>
        </div>

        <div className='newservices-boxs opacity-[0.8]' style={{ pointerEvents: 'none' }}>
          <div className='newservices-boxs-img'>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/BV-Acharya-56-removebg-preview.6310376e2f948c019163+1.png' className='object-contain w-full h-full' alt="" />
          </div>
          <div className='newservices-boxs-text'>
            <p>Advocate</p>
            <div className='newservices-boxs-text-arrow'>
              <h6>Fast Legal Help. Fewer Roadblocks </h6>
              {/* <i className="bi bi-arrow-right-circle-fill"></i> */}
            </div>
          </div>
        </div>

        <div className='bg-white newservices-boxs opacity-[0.8]' style={{ pointerEvents: 'none' }}>
          <div className='newservices-boxs-img '>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/images+3.png' className='object-contain w-full h-full' alt="" />
          </div>
          <div className='newservices-boxs-text'>
            <p>Workshop</p>
            <div className='newservices-boxs-text-arrow'>
              <h6>Expert Hands for Heavy Wheels </h6>
              {/* <i className="bi bi-arrow-right-circle-fill"></i> */}
            </div>
          </div>
        </div>

        <div className='bg-white newservices-boxs opacity-[0.8]' style={{ pointerEvents: 'none' }}>
          <div className='newservices-boxs-img' style={{ paddingBottom: '0px' }}>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/full-length-portrait-of-an-auto-mechanic-pointing-to-a-hand-truck-with-car-tires-isolated-on-white-background-2AMH47C+1.png' className='object-contain w-full h-full' alt="" />
          </div>
          <div className='newservices-boxs-text'>
            <p>Mechanic</p>
            <div className='newservices-boxs-text-arrow'>
              <h6>Mechanics on the Move </h6>
              {/* <i className="bi bi-arrow-right-circle-fill"></i> */}
            </div>
          </div>
        </div>
      </div>




      <CurrentOrdersList />

      <BottomNavigationCustomer />
    </div>
  );
}
export default AllServices;
